/* import __COLOCATED_TEMPLATE__ from './lose-benefits-modal.hbs'; */
/* RESPONSIBLE TEAM: team-growth-opportunities */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { startSurvey } from 'embercom/lib/intercom-widget-helper';
import { SELF_SERVE_CHURN_SURVEY_ID } from 'embercom/lib/billing/surveys';

interface Signature {
  Args: {
    isOpen: boolean;
    onModalClose: () => void;
  };
}
export default class LoseBenefitsModal extends Component<Signature> {
  @service appService: any;
  @service intercomEventService: any;

  get app() {
    return this.appService.app;
  }

  get planName() {
    return 'advanced';
  }

  @action
  handleCancellation() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'continue_to_cancel_subscription',
      section: 'cancel_subscription.lose_benefits_modal',
      place: 'billing_settings',
    });
    startSurvey(SELF_SERVE_CHURN_SURVEY_ID);
  }

  @action
  handleModalClose() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'stay_on_subscription_plan',
      section: 'cancel_subscription.lose_benefits_modal',
      place: 'billing_settings',
    });
    this.args.onModalClose();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Billing::Settings::LoseBenefitsModal': typeof LoseBenefitsModal;
    'billing/settings/lose-benefits-modal': typeof LoseBenefitsModal;
  }
}
